const AnimationLookbackSpan = {
    OneMonth: "1 month",
    SixMonths: "6 months",
    OneYear: "1 year",
    ThreeYears: "3 years",
    Max: "Max"
}
export default AnimationLookbackSpan;